import React, { Component } from 'react';
import {observer} from 'mobx-react';
import Select from 'react-select';

// Be sure to include styles at some point, probably during your bootstrapping
import 'react-select/dist/react-select.css';

@observer
class Currencies extends Component {

    constructor(props) {
        super(props);
        this.updateCurrency = this.updateCurrency.bind(this);
    }

    updateCurrency(option) {
        let selectedCurrency = option.value;
        let appState = this.props.appState;
        if (selectedCurrency) {
            let currencies = appState.currencies || [];
            for (let i=0; i<currencies.length; i++) {
                let curCurrency = currencies[i];
                if (curCurrency.symbol === selectedCurrency) {
                    appState.currency = curCurrency;
                    window.localStorage.currency = JSON.stringify(curCurrency);
                    break;
                }
            }
        }

        return true;
    }

    render() {
        let selectedCurrencySymbol = this.props.appState.currency.symbol || 'USD';
        let currencies = this.props.appState.currencies || [];
        let currencyList = currencies.map(currency => {
            // selected={selectedCurrencySymbol === currency.symbol}
            return {
                value: currency.symbol,
                label: currency.name + ' (' + currency.symbol + ')'
            };
        });

        return (
            <div className="">
                Choose display currency:
                <Select
                    value={selectedCurrencySymbol}
                    className="currency-selector"
                    onChange={this.updateCurrency}
                    options={currencyList}
                    clearable={false}
                    instanceId={'currencySelect'}
                />
            </div>
        );
    }
}

export default Currencies;



// WEBPACK FOOTER //
// ./src/Currencies.js